<template>
    <div>
        <PCService 
            v-if="getJson && isMobile === false" 
            :json="json"
        />
        <MobService 
            v-else-if="getJson && isMobile === true" 
            :json="json"
         />
    </div>
</template>
<script>

import PCService from '@/components/pc/PCService'
import MobService from '@/components/mobile/MobService'

// import jquery from 'jquery'

import serviceJson from '@/json/service'

import '@/assets/less/module/module-base-list-ulmoudle1_service-list-ul.less'

export default {
    name: 'Service',
    props: {
        isMobile: Boolean
    },
    components: {
        PCService,
        MobService
    },
    data: function(){
        return {
            getJson: true,
            json: serviceJson
        }
    },
    mounted() {
        // let _this = this;
        // window.getAjaxJson = {};
        // jquery.get('./json/service.js', function(){
        //    _this.json =  window.getAjaxJson;
        //    _this.getJson = true;
        // });       
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
/*导航*/
.example-title {
    padding: 12px 0 50px;
}

.title-box {
    padding-top: 50px;
    padding-bottom: 30px;
}
.service-desc {
    padding-top: 50px;
}


.service-list {
    max-width: 1200px;
    margin: 0 auto;
}

.service-list-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-height: 62px;
    border-left: 2px #333 solid;
    padding-left: 20px;
    margin-bottom: 50px;
    font-size: 38px;
}

</style>